"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationIssues = void 0;
const react_1 = __importStar(require("react"));
function ConfigurationIssues(props) {
    return (react_1.default.createElement("section", { "aria-labelledby": "ConfigurationIssuesHeader" },
        react_1.default.createElement("h3", { id: "ConfigurationIssuesHeader" }, "Configuration issues detected. See below for details."),
        react_1.default.createElement("dl", null, props.issues.map((issue) => (react_1.default.createElement(react_1.Fragment, { key: issue.name },
            react_1.default.createElement("dt", null, issue.name),
            react_1.default.createElement("dd", null, issue.message)))))));
}
exports.ConfigurationIssues = ConfigurationIssues;
//# sourceMappingURL=ConfigurationIssues.js.map